import { createContext, useState, useContext, useMemo, useCallback } from 'react';
import { registerMenuContext } from './index';
import { usePermissions } from './PermissionsContext';
const MenuContext = createContext();
registerMenuContext(MenuContext);

const isMenuEnabled = menuId => {
  const envKey = `REACT_APP_MENU_${menuId.replace(/([A-Z])/g, '_$1').toUpperCase()}`;
  const value = process.env[envKey];

  if (value === undefined) {
    return true;
  }

  return value === 'true';
};

const MENU_CONFIG = {
  dashboard: {
    id: 'dashboard',
    title: 'Dashboard',
    icon: 'monitor-dashboard',
    route: '/pages/dashboard-ouvidoria',
    submenus: [
      // {
      //   id: 'dashboard',
      //   title: 'Dashboard',
      //   icon: 'monitor-dashboard',
      //   route: '/pages',
      //   submenus: []
      // },
      {
        id: 'dashboardouvidoria',
        title: 'Dashboard Ouvidoria',
        icon: 'chart-bar',
        route: '/pages/dashboard-ouvidoria',
        submenus: []
      }
    ]
  },
  vagas: {
    id: 'vagas',
    title: 'Vagas',
    icon: 'cart-outline',
    route: '/pages/vagas',
    submenus: [
      {
        id: 'vagas',
        title: 'Processos em aberto',
        icon: 'cart-outline',
        route: '/pages/vagas/processosemaberto',
        submenus: []
      },
      {
        id: 'sugestaofrota',
        title: 'Processos encerrados',
        icon: 'cog',
        route: '/pages/vagas/processosencerrados',
        submenus: []
      }
    ]
  },
  candidato: {
    id: 'candidato',
    title: 'Candidatos',
    icon: 'paperclip',
    route: '/pages/candidato',
    submenus: [{
      id: 'candidato',
      title: 'Candidatos',
      icon: 'paperclip',
      route: '/pages/candidato',
      submenus: []
    }]
  },
  beneficios: {
    id: 'beneficios',
    title: 'Benefícios',
    icon: 'plus',
    route: '/pages/beneficios',
    submenus: [{
      id: 'beneficios',
      title: 'Benefícios',
      icon: 'plus',
      route: '/pages/beneficios',
      submenus: []
    }]
  },
  motivoouvidoria: {
    id: 'motivoouvidoria',
    title: 'Motivos da Ouvidoria',
    icon: 'comment-alert-outline',
    route: '/pages/motivoouvidoria',
    submenus: [{
      id: 'motivoouvidoria',
      title: 'Motivos da Ouvidoria',
      icon: 'comment-alert-outline',
      route: '/pages/motivoouvidoria',
      submenus: []
    }]
  },
  ouvidoria: {
    id: 'ouvidoria',
    title: 'Ouvidoria',
    icon: 'message',
    route: '/pages/ouvidoria',
    submenus: [{
      id: 'ouvidoria',
      title: 'Ouvidoria',
      icon: 'message',
      route: '/pages/ouvidoria',
      submenus: []
    }]
  },
  tagsouvidoria: {
    id: 'tagsouvidoria',
    title: 'Tags da Ouvidoria',
    icon: 'clipboard-text',
    route: '/pages/tagsouvidoria',
    submenus: [{
      id: 'tagsouvidoria',
      title: 'Tags da Ouvidoria',
      icon: 'clipboard-text',
      route: '/pages/tagsouvidoria',
      submenus: []
    }]
  },
  filiaisouvidoria: {
    id: 'filiaisouvidoria',
    title: 'Filiais',
    icon: 'office-building',
    route: '/pages/filiaisouvidoria',
    submenus: [{
      id: 'filiaisouvidoria',
      title: 'Filiais',
      icon: 'office-building',
      route: '/pages/filiaisouvidoria',
      submenus: []
    }]
  },
  /* pedidos: {
    id: 'pedidos',
    title: 'Pedidos',
    icon: 'cart-outline',
    route: '/pages/pedidos',
    submenus: [
      {
        id: 'pedidos',
        title: 'Pedidos',
        icon: 'cart-outline',
        route: '/pages/pedidos',
        submenus: []
      },
      {
        id: 'sugestaofrota',
        title: 'Planejamento de Pedidos',
        icon: 'cog',
        route: '/pages/planejamentopedidos',
        submenus: []
      }
    ]
  },
  ctes: {
    id: 'ctes',
    title: 'CTEs',
    icon: 'file-document-outline',
    route: '/pages/ctes',
    submenus: []
  },
  notasfiscais: {
    id: 'notasfiscais',
    title: 'Notas Fiscais',
    icon: 'receipt-text',
    route: '/pages/notasfiscais',
    submenus: []
  },
  acompanhamentos: {
    id: 'acompanhamentos',
    title: 'Acompanhamentos',
    icon: 'monitor-dashboard',
    route: '/pages/acompanhamentos',
    submenus: []
  },
  notificacoes: {
    id: 'notificacoes',
    title: 'Notificações',
    icon: 'bell-outline',
    route: '/pages/notificacoes',
    submenus: []
  },
  divergencias: {
    id: 'divergencias',
    title: 'Divergências',
    icon: 'alert-circle-outline',
    route: '/pages/divergencias',
    submenus: []
  },
  ordensEmissao: {
    id: 'ordensEmissao',
    title: 'Ordens de Emissão',
    icon: 'file-document',
    route: '/pages/ordens-emissao',
    submenus: []
  },
  previsaoCargas: {
    id: 'previsaoCargas',
    title: 'Previsão de Cargas',
    icon: 'truck-delivery',
    route: '/pages/previsao-cargas',
    submenus: []
  },
  workflows: {
    id: 'workflows',
    title: 'Workflows',
    icon: 'cog',
    route: '/pages/workflows',
    submenus: []
  }, */
};
export const MenuProvider = ({
  children
}) => {
  const {
    hasRight,
    hasAnyRight,
    hasProfile
  } = usePermissions(); // Filtrar menus baseado nas permissões do usuário

  const availableMenus = useMemo(() => {
    const filteredMenus = {};
    Object.entries(MENU_CONFIG).forEach(([key, menu]) => {
      if (!isMenuEnabled(menu.id)) {
        return;
      }

      // Verificar se usuário tem direitos para o menu principal
      // Se rights não estiver definido, o menu é sempre acessível
      const hasMenuAccess = menu.rights ? hasAnyRight(menu.rights) : true;

      if (hasMenuAccess) {
        // Filtrar submenus baseado nas permissões
        const availableSubmenus = menu.submenus.filter(submenu => {
          if (!isMenuEnabled(submenu.id)) {
            return false;
          }

          return submenu.rights ? hasAnyRight(submenu.rights) : true;
        }); // Incluir menu se tiver submenus disponíveis OU se for um menu direto (sem submenus)

        if (availableSubmenus.length > 0 || menu.submenus.length === 0) {
          filteredMenus[key] = {
            ...menu,
            submenus: availableSubmenus
          };
        }
      }
    });
    return filteredMenus;
  }, [hasAnyRight]); // Verificar se um menu específico está disponível

  const isMenuAvailable = useCallback(menuId => {
    return !!availableMenus[menuId];
  }, [availableMenus]); // Verificar se um submenu específico está disponível

  const isSubmenuAvailable = useCallback((menuId, submenuId) => {
    const menu = availableMenus[menuId];
    if (!menu) return false;
    return menu.submenus.some(submenu => submenu.id === submenuId);
  }, [availableMenus]); // Obter todos os menus disponíveis

  const getAvailableMenus = useCallback(() => {
    return Object.values(availableMenus);
  }, [availableMenus]); // Obter um menu específico

  const getMenu = useCallback(menuId => {
    return availableMenus[menuId] || null;
  }, [availableMenus]); // Obter submenus de um menu específico

  const getSubmenus = useCallback(menuId => {
    const menu = availableMenus[menuId];
    return menu ? menu.submenus : [];
  }, [availableMenus]); // Verificar se usuário tem acesso a uma rota específica

  const hasRouteAccess = useCallback(route => {
    // Procurar em todos os menus e submenus
    for (const menu of Object.values(availableMenus)) {
      // Verificar menu principal
      if (menu.route === route) {
        return menu.rights ? hasAnyRight(menu.rights) : true;
      } // Verificar submenus


      for (const submenu of menu.submenus) {
        if (submenu.route === route) {
          return submenu.rights ? hasAnyRight(submenu.rights) : true;
        }
      }
    }

    return false;
  }, [availableMenus, hasAnyRight]); // Obter menu e submenu de uma rota específica

  const getMenuByRoute = useCallback(route => {
    for (const [menuKey, menu] of Object.entries(availableMenus)) {
      // Verificar menu principal
      if (menu.route === route) {
        return {
          menu,
          submenu: null,
          menuKey
        };
      } // Verificar submenus


      for (const submenu of menu.submenus) {
        if (submenu.route === route) {
          return {
            menu,
            submenu,
            menuKey
          };
        }
      }
    }

    return null;
  }, [availableMenus]); // Verificar se usuário é administrador

  const isAdmin = useMemo(() => {
    return hasProfile('administrador');
  }, [hasProfile]); // Verificar se usuário é comercial

  const isComercial = useMemo(() => {
    return hasProfile('comercial');
  }, [hasProfile]); // Verificar se usuário é operador

  const isOperador = useMemo(() => {
    return hasProfile('operador');
  }, [hasProfile]);
  const value = useMemo(() => ({
    availableMenus,
    isMenuAvailable,
    isSubmenuAvailable,
    getAvailableMenus,
    getMenu,
    getSubmenus,
    hasRouteAccess,
    getMenuByRoute,
    isAdmin,
    isComercial,
    isOperador
  }), [
    availableMenus,
    isMenuAvailable,
    isSubmenuAvailable,
    getAvailableMenus,
    getMenu,
    getSubmenus,
    hasRouteAccess,
    getMenuByRoute,
    isAdmin,
    isComercial,
    isOperador
  ]);
  return <MenuContext.Provider value={value}>
    {children}
  </MenuContext.Provider>;
};
export const useMenu = () => {
  const context = useContext(MenuContext);

  if (!context) {
    throw new Error('useMenu deve ser usado dentro de um MenuProvider');
  }

  return context;
};



